import { apiSlice } from '../api/apiSlice'
import { BaseApiResponse } from '../shared/shared.type'

export type PricePreference = 'affordable' | 'balanced' | 'premium' | 'any'
export type SpendingOption = {
  _id?: string
  label: string
  icon?: string
  pricePreference?: PricePreference
  interestIds?: string[]
}
export type SpendingQuestionBody = {
  title: string
  description: string
  options: SpendingOption[]
  isActive: boolean
  displayOrder: number
}
export type SpendingQuestion = SpendingQuestionBody & { _id: string }

export const spendingQuestionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSpendingQuestions: builder.query<SpendingQuestion[], void>({
      query: () => 'v2/spending-questions',
      transformResponse: (
        response: BaseApiResponse<{ questions: SpendingQuestion[] }>,
      ) => response.data.questions,
      providesTags: ['SPENDING_QUESTION'],
    }),
    createSpendingQuestion: builder.mutation<
      BaseApiResponse<SpendingQuestion>,
      SpendingQuestionBody
    >({
      query: (body) => ({ url: 'v2/spending-questions', method: 'POST', body }),
      invalidatesTags: ['SPENDING_QUESTION'],
    }),
    updateSpendingQuestion: builder.mutation<
      BaseApiResponse<SpendingQuestion>,
      { id: string; body: Partial<SpendingQuestionBody> }
    >({
      query: ({ id, body }) => ({
        url: `v2/spending-questions/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['SPENDING_QUESTION'],
    }),
  }),
})

export const {
  useGetSpendingQuestionsQuery,
  useCreateSpendingQuestionMutation,
  useUpdateSpendingQuestionMutation,
} = spendingQuestionApi
